import React from 'react'

import { IMAGE_SIZES } from '@hozana/styling/image'
import { QA } from '@hozana/tests/constants'

import { BorderedDiv } from 'elements/layout/BorderedDiv'
import { PreloadDiv } from 'elements/layout/PreloadDiv'
import { Shadow } from 'elements/layout/Shadow'
import { BgImage, TBgImageProps } from 'elements/media/BgImage'

export type TCommunityBgImageProps = {
  image?: TBgImageProps['src']
} & Omit<TBgImageProps, 'src'>

export const CommunityBgImage: TFCC<TCommunityBgImageProps> = ({ image, ...otherProps }) => (
  <PreloadDiv as={BorderedDiv} noOverflow noBorder borderRadius={{ xs: '0', lg: '10px 10px 0 0' }} align="middleCenter">
    <BgImage
      src={image}
      bgSize="cover"
      bg="white"
      bgPosition="center center"
      maxW="100%"
      w={{ xs: 1, lg: '990px' }}
      h="calc(100vw / 2.32)" // force to keep the proportion 990px x 427px
      maxH="427px"
      imageSize={IMAGE_SIZES.community.big}
      data-testid={QA.COMMUNITY_PAGE.IMAGE}
      {...otherProps}
    >
      <Shadow inset depth="8px" x="0" y="-12px" opacity="0.3" spread="-8px" w="100%" h="100%" />
    </BgImage>
  </PreloadDiv>
)
